import SimpleRiskChip from '@app/src/pages/Assessments/AssessmentCompanyPage/SimpleRiskChip'
import { AllTabs } from '@app/src/pages/ResourceExplorer/Content'
import type { Provider } from '@app/src/types/organizations'
import type { RiskStatus } from '@app/src/types/resourceExplorer'
import paths from '@app/src/wf-constants/paths'
import { Skeleton } from '@mui/material'
import React from 'react'
import { generatePath } from 'react-router'
import EmptyCell from './EmptyCell'
import ParentCellOrFragment from './ParentCellOrFragment'

export type ProviderOverallRiskCellProps = {
  provider: Provider
  riskStatus?: RiskStatus
  isLoading?: boolean
  disableCell?: boolean
}

const ProviderOverallRiskCell: React.FC<ProviderOverallRiskCellProps> = ({
  provider,
  riskStatus,
  isLoading,
  disableCell,
}) => {
  if (isLoading) {
    return (
      <ParentCellOrFragment disableCell={disableCell}>
        <Skeleton variant="rounded" width={72} height={24} />
      </ParentCellOrFragment>
    )
  }

  if (!riskStatus) {
    return <EmptyCell disableCell={disableCell} />
  }

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <SimpleRiskChip
        riskStatus={riskStatus}
        to={generatePath(paths.resourceExplorer, {
          resourceType: provider.type.toLowerCase(),
          resourceId: provider.id,
          activeTabParam: AllTabs.TopicalRisk,
        })}
      />
    </ParentCellOrFragment>
  )
}

export default ProviderOverallRiskCell
